module.exports = __webpack_public_path__ + "d205a83e0c89927f5f45b32fba6667d0.gif";